import {useQuery} from "react-query";
import {getDiscardReasons} from "../restapi/discard-reason";


export function useRetrieveDiscardReasons() {
    return useQuery(['discard-reasons'], () => getDiscardReasons(), {
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 10 * 60 * 1000 // 10 minutes
    });
}
